<template>
  <div id="playercontent">
    <div id="dplayer" @dblclick="fullScreen"></div>
  </div>
</template>

<script>
import Hls from 'hls.js'
import DPlayer from 'dplayer';

export default {
  props: {
    playParam: Object,
    pointData: '',
  },
  data() {
    return {
      videoCurrentTime: '',
      videoUrl: '',
      isFullScreen: false,
      observer: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initDPlayer();
      this.getCurrentTime();
      this.getConfig()
    })
  },
  beforeDestroy() {
    this.observer.disconnect();
  },

  methods: {
    getConfig() {
      let success = (res) => {
        let result = res.data.safe_show
        if (result === 1) {
          this.ipRuning()
        }
      }
      this.$ajax('/api/video/live_app_show', {
        params: { type: 3 },
        func: { success }
      })
    },
    domObserver(targetNode) {
      const config = {
        childList: true,
        attributes: true,
        subtree: true
      }
      const callback = (mutationsList, observer) => {
        for (let mutation of mutationsList) {
          let remove = mutation.removedNodes[0]
          if (mutation.type === 'childList' && (remove && remove.className === 'ipRuning')) {
            let isExit = document.getElementById('dplayer').childNodes[0].className === 'ipRuning'
            if (!isExit) {
              this.ipRuning('observer')
            }
            // 使用nextTick函数是防止生成新的定时器时，还没有清除上次的定时器，
          }
        }
      }
      this.observer = new MutationObserver(callback)
      this.observer.observe(targetNode, config);
    },
    // 获取指定范围内随机数的函数
    getRandomIntInclusive(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min; //含最大值，含最小值
    },
    ipRuning(isObserve) {
      // 用来生成水印dom的函数
      // 如果携带参数，则说明需要生成dom，但不需要生成观测器
      let top = this.getRandomIntInclusive(5, 96)
      let divText = '当前用户：' + JSON.parse(sessionStorage.getItem('user_info_str')).id + '，' +JSON.parse(sessionStorage.getItem('user_info_str')).name
      let aDOM = document.getElementById('dplayer')

      let newDiv = document.createElement('div')
      newDiv.innerHTML = divText
      newDiv.className = 'ipRuning'
      newDiv.style.top = top + '%'
      aDOM.insertBefore(newDiv, aDOM.firstChild)
      if (!isObserve) this.domObserver(aDOM);

      setTimeout(() => {
        newDiv.remove();
      }, 15000);
    },
    initDPlayer() {
      this.videoUrl = this.playParam.play_url;
      // this.showQuality();
      const hls = new Hls();
      const dp = {
        container: document.getElementById('dplayer'),
        //播放器的一些参数
        autoplay: true,                                                   //视频自动播放
        theme: '#FADFA3',                                                 //主题色
        loop: false,                                                      //视频循环播放
        lang: 'zh-cn',                                                    //语言
        screenshot: true,                                                 //开启截图，如果开启，视频和视频封面需要允许跨域
        hotkey: true,                                                     //开启热键，支持快进、快退、音量控制、播放暂停
        preload: 'auto',                                                  //视频预加载，可选值: 'none', 'metadata', 'auto'
        // logo: require('logo.png'),                                     //左上角logo
        volume: 0.7,                                                      //默认音量，请注意播放器会记忆用户设置，用户手动设置音量后默认音量即失效
        mutex: true,                                                      //互斥，阻止多个播放器同时播放，当前播放器播放时暂停其他播放器
        playbackSpeed: [0.5, 0.75, 1, 1.25, 1.5, 2],                      //可选的播放速率，可以设置成自定义的数组
        video: {                                                          //视频信息
          url: this.videoUrl,                                             //视频链接    
          type: 'auto',                                              //可选值: 'auto', 'hls', 'flv', 'dash', 'webtorrent', 'normal' 或其他自定义类型, 见#MSE 支持
          customType: {
            customHls: function (video, player) {
              hls.loadSource(video.src);
              hls.attachMedia(video);
            },
          },
          pic: 'dplayer.png',                                             //视频封面
          // thumbnails: 'thumbnails.jpg',                                //视频缩略图，可以使用 DPlayer-thumbnails (opens new window)生成
          quality: this.qulity,
          defaultQuality: 0,
        },
        highlight: this.pointData,                                       //高亮点（打点功能）
      };
      const player = new DPlayer(dp);
      this.player = player
    },
    getCurrentTime() {
      let _this = this
      this.player.video.ontimeupdate = function () {
        _this.videoCurrentTime = parseInt(_this.player.video.currentTime)
      }

    },
    fullScreen() {
      if (this.isFullScreen) {
        this.player.fullScreen.cancel('browser');
        this.isFullScreen = false;
      } else {
        this.player.fullScreen.request('browser');
        this.isFullScreen = true;
      }
    }

    // showQuality() {
    //   let qualityAll = [                                                     //清晰度
    //     {
    //       name: '480P',
    //       url: this.options['480P'],
    //       type: 'customHls',
    //     },
    //     {
    //       name: '720P',
    //       url: this.options['720P'],
    //       type: 'customHls',
    //     },
    //     {
    //       name: '1080P',
    //       url: this.options['1080P'],
    //       type: 'customHls',
    //     },
    //     {
    //       name: '原视频',
    //       url: this.options.pc_play_url,
    //       type: 'customHls',
    //     },]
    //   if (this.options['1080P']) {
    //     this.qulity.push(qualityAll[2])
    //   }
    //   if (this.options['720P']) {
    //     this.qulity.push(qualityAll[1])
    //   }
    //   if (this.options['480P']) {
    //     this.qulity.push(qualityAll[0])
    //   }
    //   if (this.qulity.length == 0) {
    //     this.qulity.push(qualityAll[3])
    //   }

    // },

  },

}
</script>
<style lang="scss" scoped>
:deep(#dplayer) {
  height: 100%;
  .dplayer-video-current {
    /* width: auto; */
    height: 100%;
    margin: 0 auto;
  }
  .dplayer-video-wrap {
    height: 100%;
  }
  .dplayer-video {
    height: 100%;
  }
  .dplayer-setting-loop {
    display: none;
  }
  .dplayer-setting-item {
    line-height: 18px;
  }
}



 :deep(.ipRuning ){
  white-space: nowrap;
  position: absolute;
  // top: 96;
  // left: 90%;
  z-index: 100;
  color: gray;
  font-size: 1.5rem;
  animation-name: runing;
  animation-duration: 15s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}


@keyframes runing {
  from {
    left: 0;
  }

  to {
    left: 100%
  }
}
</style>